import { useEffect, useState } from "react";
import { _CreditProcessMovement, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../../../theme/Component/BasicPage"
import { CompanyEditor } from "../../../../../erp/cellEditor/Company/CompanyEditor";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { CustomProcessTypeSeleect } from "../../../../../erp/cellEditor/CustomProcessType/CustomProcessTypeSeleect";
import { SelectTypeProcees } from "../../../../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { BudgetAccountantOperationSelect } from "../../../../../erp/cellEditor/BudgetAccountantOperation/BudgetAccountantOperationSelect";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { YearSelector } from "../../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../../contract/select/SelectMonths";
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { toast } from "react-toastify";

export const PagoDescuentoNomina = () => {

    const _credit = useDataBean(_CreditProcessMovement);
    const { setLista, lista, setBean, bean } = _credit;
    const [param, setParam] = useState<any>({
        IDCompany: 1,
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth()
    });
    const [payroll, setPayroll] = useState<any>([]);
    const [response, setRespose] = useState<any>({});
    const [errMessage, setErrMessage] = useState<any>([]);

    useEffect(() => {
        _credit.instance.getLoanLinePayrollFactorList(param.IDCompany).then(
            (resp: any) => {
                console.log(resp);
                setPayroll(resp);
                if (resp.length > 0) {
                    setParam({ ...param, "IDPayrollFactor": resp[0].DataBeanProperties.IDPayrollFactor });
                }
            }
        )
    }, [param.IDCompany])



    const grabarProceso = () => {

        // if (param.Year
        //     && param.Month
        //     && param.IDPayrollFactor
        //     && param.CustomProcessType
        //     && param.AccountantDate
        //     && param.idBudgetAccountantOperation
        // ) {
        _credit.instance.parseQuotaCredit(param.Year, param.Month, param.IDPayrollFactor, param.CustomProcessType, param.AccountantDate, param.idBudgetAccountantOperation, _single.getAccountID()).then(
            (resp: any) => {
                setRespose(resp);
            }
        )

        // } else {
        //     toast.warning("Faltan parametros en el formulario");
        // }

    }

    const consultarPagos = () => {
        if (param.Year != null && param.Month != null && param.IDPayrollFactor >= 0) {
            _credit.instance.validarCuotasByNomina(param.Year, param.Month, null, param.IDPayrollFactor).then(
                (resp: any) => {
                    let temp: any = [];
                    resp.forEach(element => {
                        updateCuotas(element);
                        temp.push({
                            DataBeanProperties: element
                        })
                    });
                    setLista(temp);
                }
            )
        } else {
            toast.warning("Año, Mes y Pay Roll son obligatorios");
        }

    }

    const updateCuotas = (item: any) => {
        let valor = 0;
        let credito = '';
        try {
            if (Array.isArray(item.Cuota)) {
                const arr = item.Cuota;


                const creditosList: string[] = arr.map(element => {
                    valor += parseFloat(element.Value);
                    return element.LoanNumber ?? '';
                });


                credito = creditosList.filter(c => c !== '').join(', ');
            }
        } catch (error) {
            console.error(error);
        }

        item.CuotaMes = valor;
        item.LoanNumber = credito;
    };

    const head = [
        { title: 'Identificacion', property: 'EmployeeID', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'EmployeeName', visible: true },
        { title: 'Descuento', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Cuota Mes', property: 'CuotaMes', visible: true, mask: MASK_MONEY },
        { title: 'Crédito', property: 'LoanNumber', visible: true },
        { title: 'Mensaje', property: 'CuotaError', visible: true },
    ]


    return (
        <BasicPage titulo="Aplicar Abonos de Cartera desde Descuentos de Nómina">
            <div className="row">
                <div className="col-md-2">
                    <YearSelector value={param.Year} onChange={(e) => { setParam({ ...param, "Year": e }) }} />
                </div>
                <div className="col-md-2">
                    <SelectMonths idSelector={param.Month} onChange={(e) => { setParam({ ...param, "Month": e }) }} />
                </div>
                <div className="col-md-4">
                    <CompanyEditor id={param.IDCompany} onchange={(e) => { setParam({ ...param, "IDCompany": e }) }} />
                </div>
                <div className="col-md-4">
                    <label>Payroll a Aplicar</label>
                    <select name="payroll" className="form-select" value={param.IDPayrollFactor} onChange={(e) => { setParam({ ...param, "IDPayrollFactor": parseInt(e.target.value) }) }}>
                        {payroll.map((item: any, index: number) => {
                            return (
                                <option value={item.DataBeanProperties.IDPayrollFactor}>{item.DataBeanProperties.Name}</option>
                            )
                        })}
                    </select>
                </div>
                <div className="col-md-4">
                    <SelectTypeProcees label="Tipo de Proceso" idSelector={param.ProcessType} onChange={(e) => setParam({ ...param, "ProcessType": e })} />
                </div>
                <div className="col-md-4">
                    <CustomProcessTypeSeleect processType={param.ProcessType} idSelector={param.CustomProcessType} onChange={(e) => setParam({ ...param, "CustomProcessType": e })} />
                </div>
                <div className="col-md-4">
                    <InputDate label="Fecha de Registro Contable" name="accountantDate" value={param.AccountantDate} setDate={(e) => { setParam({ ...param, "AccountantDate": e }) }} />
                </div>
                <div className="col-md-4">
                    <BudgetAccountantOperationSelect label="Proceso Contable Presupuestal" idSelector={param.idBudgetAccountantOperation} onChange={(e) => { setParam({ ...param, "idBudgetAccountantOperation": e }) }} />
                </div>
                {/* <div className="col-md-12"></div> */}
                <div className="col-md-4 ">
                    <BasicButton icon="ri-wallet-2-line" eventClick={consultarPagos} useMargin>Validar Descuento</BasicButton>
                    <BasicButton disable={response.ReportList} icon="ri-save-3-line" useMargin eventClick={grabarProceso}>Grabar</BasicButton>
                </div>
                <div className="col-md-12">
                    {/* <PrintJson json={response} /> */}
                    {response.ReportList &&
                        <DocumentViewer list={response.ReportList} />
                    }
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} />
                    {/* <PrintJson json={lista}/> */}
                </div>
            </div>


        </BasicPage>
    )
}